module.exports = __webpack_public_path__ + "static/media/CTLI_13-147w.dd999537.jpg";